export default function modalFiltrar(wrapperBadge, wrapperFields) {
	const attr = document.querySelector("[js-modal-filtrar]")

	if(!attr) return

	const token = 'csrfmiddlewaretoken'
	const ativos = "<p class='text-sm font-semibold text-neutral-80'>Filtros Ativos</p>"
	const btnLimpar = document.querySelector('[js-limpar-filtro]')
	
	const geraBadge = (item) => `<div class="badge">${item}</div>`


	function filtrosAtivos(wrapper) {
	

		const url = new URL(window.location)
		// const urlSearchParams = new URLSearchParams(url);
		// const params = Object.fromEntries(urlSearchParams.entries());
		// const array = Object.entries(params);	
		// console.log(params)
		let filtersOBJ = GLOBAL.splitFilters(url.search)
		console.log(url.search)
		console.log('obj', filtersOBJ)
		if (!filtersOBJ) return
		btnLimpar?.classList.remove("hidden")

		const filterArray = Object.entries(filtersOBJ)

		const template = filterArray
			.filter(([key, value]) => value && key != token)
			.map(([key, value]) => geraBadge(key.replaceAll('_', ' ')))

		template.unshift(ativos)

		wrapper.innerHTML = template.join("")

		setValueOnFields(wrapper, filtersOBJ)
	}


	
	function setValueOnFields(wrapper, obj) {
		const objArr = Object.entries(obj)

		objArr.forEach(([key, value]) => {

			const field = wrapperFields.querySelector(`[name="${key}"]`)
			if(!field) return

			const type = field.tagName
			
			if (type === "SELECT") {
				const select = GLOBAL.getChoicesActive(field.id, listOfChoices)
				select.setChoiceByValue(value)
			}
			if (type === "INPUT") {
				// const str = "ç_--áäàãa@! teste}{\ ";
				field.value = decodeURIComponent(value.replaceAll(/\+/g, ' '))
			}

		})
		
	}


	function limparFiltros() {
		const url = new URL(window.location)
		console.log(url.pathname)
		
		window.location.href = `${url.origin}${url.pathname}`
	}

	

	function init() {
		document.addEventListener("DOMContentLoaded", () => filtrosAtivos(wrapperBadge))
		btnLimpar.addEventListener("click", limparFiltros)
	
	}

	return {
		init
	}

}